import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n.use(initReactI18next).init({
  fallbackLng: 'en',
  lng: 'en',
  resources: {
    en: {
      translations: {
        home: {
          nav: require('./locales/en/home/nav.json'),
          obPd: require('./locales/en/home/overview.json'),
        },
        fotr: require('./locales/en/footer.json'),
        contact: require('./locales/en/contact.json'),
        tac: require('./locales/en/tac.json'),
        utils: require('./locales/en/utils.json'),

      }
    },
    bn: {
      translations: {
        home: {
          nav: require('./locales/bn/home/nav.json'),
          obPd: require('./locales/bn/home/overview.json')
        },
        fotr: require('./locales/bn/footer.json'),
        contact: require('./locales/bn/contact.json'),
        tac: require('./locales/bn/tac.json'),
        utils: require('./locales/bn/utils.json'),
      }
    }
  },
  ns: ['translations'],
  defaultNS: 'translations'
});

i18n.languages = ['en', 'bn'];

export default i18n;